import React from 'react';
import MenuIcon from '../../components/Icons/MenuIcon'
import UserIcon from '../../components/Icons/User'
import ChangePasswordIcon from '../../components/Icons/ChangePasswordIcon copy'
import LogOutIcon from '../../components/Icons/LogOutIcon copy'


const view = ({ items, goto, logout, userName }) => {
  return (
    <span>
      <header className="leading-loose shadow-lg px-3 lg:px-6 bg-white flex border-b flex-wrap items-center lg:py-0 py-2 font-semibold">
        <div className="flex-1 flex lg:mr-4 items-center">
          <img src="/images/logo-shape.svg" alt="Company logo" className="w-20 h-8" />
          <input className="transition lg:max-w-xs focus:outline-0 border border-transparent focus:bg-white focus:border-gray-300 placeholder-gray-600 rounded-lg bg-gray-200 p-2 block text-sm  appearance-none leading-none ds-input  lg:mr-2 w-full mr-8 ml-8 h-8 text-right" type="text" placeholder="بحــــث" autoComplete="off" spellCheck="false" aria-autocomplete="list" aria-label="search input" aria-owns="algolia-autocomplete-listbox-0" style={{ position: "relative", verticalAlign: "top" }} dir="auto" />
        </div>
        <label htmlFor="menu-toggle" className="pointer-cursor lg:hidden block">
          <MenuIcon />
        </label>
        <input className="hidden" type="checkbox" id="menu-toggle" />
        <div className="hidden wtf-menu1 lg:ml-4 lg:flex lg:items-center lg:w-auto w-full" id="menu">
          <nav>
            <ul className="lg:flex items-center justify-between text-sm pt-3 lg:pt-0 text-grey-600">
              {items}
              <li className="text-grey-900 flex items-center lg:hidden"><ChangePasswordIcon /><span className="lg:p-3 py-2 px-0 font-normal block border-b-2 border-transparent hover:border-vivid-700 pr-5 w-full" href="#" onClick={goto("/changepassword")}>تغيير كلمة السر</span></li>
              <li className="text-grey-900 flex items-center lg:hidden"><LogOutIcon /><span className="lg:p-3 py-2 px-0 font-normal block border-b-2 border-transparent hover:border-vivid-700 pr-5 w-full" href="#" onClick={logout}>تسجيل الخروج</span></li>
              <li className="text-grey-900 flex items-center lg:hidden"><UserIcon /><span className="lg:p-3 py-2 px-0 font-normal block border-b-2 border-transparent hover:border-vivid-700 pr-5 w-full" href="#">{userName}</span></li>
            </ul>
          </nav>
          <div className="dropdown h-8 rounded lg:block hidden cursor-pointer">
            <div className="flex"> <UserIcon />
              <p className="text-gray-700 text-sm px-2">{userName}</p>
            </div>
            <div className="dropdown-content w-32 hidden left-0 top-auto z-50 shadow-md absolute border-grey-100 border min-w-0 text-xs bg-white ml-4">
              <span className="px-2 py-2 m-1 hover:text-cyan-500 border-b border-grey-200 block no-underline font-normal" onClick={goto("/changepassword")} href="#">تغيير كلمة السر</span>
              <span className="px-2 py-2 m-1 hover:text-cyan-500 block no-underline font-normal" onClick={logout} href="#">تسجيل الخروج</span>
            </div>
          </div>

        </div>
      </header>
    </span>

  );
};

export default view;